export const ErrorBackend = (props: { errorsBackend: any; name: string }) => {
  return props.errorsBackend && props.errorsBackend[props.name] ? (
    <div className="form-group__error">
      {props.errorsBackend[props.name].map((error: string, index: number) => (
        <p key={index}>{error}</p>
      ))}
    </div>
  ) : null;
};

export default ErrorBackend;
